import { createContext } from 'react';

import { TimeseriesUnit } from '../../core/types/timeseries.js';
import {
  WeakMapSeries,
  ValueRepresentationPerVariant,
  TimeseriesSlotProps,
  TimeseriesPerVariant,
} from '../types/timeseries.js';

export type TimeseriesData = {
  dataPerVariant: TimeseriesPerVariant;
  data: TimeseriesSlotProps[];
  valueRepPerVariant: ValueRepresentationPerVariant;
  seriesMap: WeakMapSeries;
  units: TimeseriesUnit[];
};

export const TimeseriesDataContext = createContext<TimeseriesData>({
  dataPerVariant: {
    area: [],
    bar: [],
    band: [],
    line: [],
    shapePriority: [],
  },
  data: [],
  units: [],
  valueRepPerVariant: new Map(),
  seriesMap: new WeakMap(),
});

TimeseriesDataContext['displayName'] = 'TimeseriesDataContext';
